module.exports = __webpack_public_path__ + "static/media/shakephone.3291d095.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/shakephone.svg
// module id = 161
// module chunks = 0